<!-- components/Sidebar.vue -->
<template>
  <div class="sidebar">
    <ul class="sidebar-menu">
      <li class="menu-item">
        <router-link to="/">
          <i class="fas fa-home"></i> 返回首页
        </router-link>
      </li>
      <li class="menu-item">
        <router-link to="/product-management">
          <i class="fas fa-box"></i> 产品编辑
        </router-link>
      </li>
      <li class="menu-item">
        <router-link to="/upload-images">
          <i class="fas fa-images"></i> 上传图片
        </router-link>
      </li>
      <li class="menu-item">
        <router-link to="/about">
          <i class="fas fa-info-circle"></i> 关于我们
        </router-link>
      </li>
      <li class="menu-item">
        <router-link to="/contact">
          <i class="fas fa-address-book"></i> 联系我们
        </router-link>
      </li>
      <li class="menu-item">
        <router-link to="/environment">
          <i class="fas fa-leaf"></i> 环境保护
        </router-link>
      </li>
      <li class="menu-item">
        <router-link to="/quality">
          <i class="fas fa-check-circle"></i> 质量控制
        </router-link>
      </li>
      <li class="menu-item">
        <router-link to="/join">
          <i class="fas fa-users"></i> 加入我们
        </router-link>
      </li>
      <li class="menu-item">
        <router-link to="/service">
          <i class="fas fa-headset"></i> 售后服务
        </router-link>
      </li>
      <li class="menu-item logout-item">
        <a @click.prevent="logout">
          <i class="fas fa-sign-out-alt"></i> 登出
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Sidebar',
  methods: {
    logout() {
      // 清除 token
      localStorage.removeItem('token');
      // 重定向到登录页面
      this.$router.push('/login');
    }
  }
};
</script>

<style scoped>
.sidebar {
  width: 200px;
  background: #2c3e50;
  color: white;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  padding-top: 20px;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);
}

.sidebar-menu {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.menu-item {
  padding: 15px 20px;
  font-size: 16px;
  transition: background 0.3s ease;
}

.menu-item a {
  color: white;
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 10px;
}

.menu-item:hover {
  background: #34495e;
}

.menu-item .router-link-active {
  background: #34495e;
  font-weight: bold;
}

.logout-item {
  margin-top: auto; /* 将登出按钮推到底部 */
}

.logout-item a {
  color: white;
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
}

.logout-item:hover {
  background: #e57373;
}
</style>